import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  getHarvestById,
  harvestActions,
  postHarvest,
} from "../../../redux/reducer/harvest/harvestReducer";
import { getVegetable } from "../../../redux/reducer/vegetable/vegetableReducer";
import NumberFormatting from "../../helper/NumberFormatting";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function FarmerHarvestDashboardTambah() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const vegetable = useSelector((state) => state.vegetable.data);
  const estimateCode = useSelector((state) => state.harvestEstimate.data);
  const farmer = useSelector((state) => state.farmer.data);

  // Local State
  const [formData, setFormData] = useState({
    farmerId: "",
    vegetableId: "",
    estimateCodeId: "",
    harvestTotal: "",
  });
  const [harvestDetails, setHarvestDetails] = useState([]);
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      handleAddHarvest();
      if (id) {
        let x = estimateCode.docs.findIndex(
          (item) => item._id === id
        );
        if (x > -1) {
          setFormData({
            ...formData,
            estimateCodeId: id,
            estimateCodeName: estimateCode.docs[x].estimateCode,
            farmerId: estimateCode.docs[x].farmerId._id,
            farmerName: estimateCode.docs[x].farmerId.fullName,
            vegetableId: estimateCode.docs[x].vegetableId._id,
            vegetableName: estimateCode.docs[x].vegetableId.vegetableName,
          });
        }
      }
      setFetch(false);
    }
  }, [fetch]);

  useEffect(() => {
    if (harvestDetails.length > 0) {
      let total = 0;
      for (let x in harvestDetails) {
        total += parseInt(harvestDetails[x].harvestAmount);
      }
      setFormData({
        ...formData,
        harvestTotal: total,
      });
    }
  }, [harvestDetails]);
  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Activity
  const handleHarvest = (index) => (e) => {
    const newItems = [...harvestDetails];
    newItems[index][e.target.name] = e.target.value;
    setHarvestDetails(newItems);
  };

  const handleAddHarvest = () => {
    setHarvestDetails((prevItems) => [
      ...prevItems,
      {
        harvestDate: "",
        harvestAmount: "",
        description: "",
      },
    ]);
  };

  const handleDeleteHarvest = (value) => {
    let deletedData = [];
    for (let i = 0; i < harvestDetails.length; i++) {
      if (i !== value) {
        deletedData.push(harvestDetails[i]);
      }
    }
    setHarvestDetails(deletedData);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          data: {
            farmerId: formData.farmerId,
            vegetableId: formData.vegetableId,
            estimateCodeId: formData.estimateCodeId,
            harvestTotal: formData.harvestTotal,
            harvestDetails: harvestDetails,
          },
          token: token,
        };
        dispatch(postHarvest(data)).then((res) => {
          if (res.payload.status === 201) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getHarvestById(dataGetById)).then((result) => {
              dispatch(harvestActions.addHarvest(result.payload.data));
              toast.success(res.payload.message);
              navigate("/petani/panen");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      } else if (vegetable.totalDocs !== vegetable.docs.length && value === 2) {
        const getData = {
          params: {
            limit: vegetable.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getVegetable(getData));
      }
    }
  };

  const harvestDetailsColumn = ["TANGGAL", "JUMLAH", "DESKRIPSI", "AKSI"];
  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          TAMBAH PANEN
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE ESTIMASI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="estimateCodeId"
              onChange={handleChange}
              value={formData.estimateCodeId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.estimateCodeId && (
                <MenuItem value={formData.estimateCodeId}>
                  {formData.estimateCodeName}
                </MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.farmerId && (
                <MenuItem value={formData.farmerId}>
                  {formData.farmerName}
                </MenuItem>
              )}
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              SAYURAN
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="vegetableId"
              onChange={handleChange}
              value={formData.vegetableId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(2),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.vegetableId && (
                <MenuItem value={formData.vegetableId}>
                  {formData.vegetableName}
                </MenuItem>
              )}
              {vegetable.docs.length > 0 ? (
                vegetable.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.vegetableName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <Divider />
          <div
            style={{
              background: "#d1cdcd",
              padding: "10px",
              borderRadius: "10px",
              margin: "10px 0px",
            }}
          >
            <Typography
              marginTop={1}
              marginBottom={1}
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
            >
              DETAIL PANEN
            </Typography>
            <table
              style={{
                width: "100%",
                marginBottom: "10px",
                borderCollapse: "collapse",
                borderRadius: "1em",
                overflow: "hidden",
              }}
            >
              <thead>
                {harvestDetailsColumn.map((item, index) => {
                  return (
                    <td className={styles.tableHeader} key={index}>
                      {item}
                    </td>
                  );
                })}
              </thead>
              <tbody>
                {harvestDetails.length > 0 &&
                  harvestDetails.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              type="date"
                              error={false}
                              name="harvestDate"
                              onChange={handleHarvest(index)}
                              value={item.harvestDate}
                              fullWidth
                              variant="outlined"
                              style={{
                                maxWidth: "400px",
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small" 
                              InputProps={{ 
                                inputComponent: NumberFormatting,
                                endAdornment : <InputAdornment position="end">kg</InputAdornment>
                              }}
                              error={false}
                              name="harvestAmount"
                              id={index}
                              onChange={handleHarvest(index)}
                              value={item.harvestAmount}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>
                        <td className={styles.tableCell}>
                          <FormControl
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyItems: "flex-start",
                              flexDirection: "row",
                              margin: "auto",
                              width: "90%",
                            }}
                          >
                            <TextField
                              InputLabelProps={{ shrink: true }}
                              required
                              size="small"
                              inputProps={{ maxLength: 250 }}
                              error={false}
                              name="description"
                              id={index}
                              onChange={handleHarvest(index)}
                              value={item.description}
                              variant="outlined"
                              fullWidth
                              style={{
                                background: "white",
                                marginRight: "10px",
                              }}
                            />
                          </FormControl>
                        </td>

                        <td className={styles.tableCell}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "auto",
                              width: "100px",
                            }}
                          >
                            <AddIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleAddHarvest()}
                            />
                            {harvestDetails.length > 1 && index !== 0 ? (
                              <RemoveIcon
                                className={styles.actionButtonEdit}
                                onClick={() => handleDeleteHarvest(index)}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <Divider />
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              marginTop: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL PANEN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              inputProps={{ readOnly: true }} 
              InputProps={{ 
                inputComponent: NumberFormatting,
                endAdornment : <InputAdornment position="end">kg</InputAdornment>
              }}
              size="small"
              error={false}
              name="harvestTotal"
              onChange={handleChange}
              value={formData.harvestTotal}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/panen")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
